import html2canvas from "html2canvas";
import jsPDF from "jspdf";

function withTimeout(promise, milliseconds) {
  let timer;
  return Promise.race([
    promise,
    new Promise((resolve, reject) => {
      timer = setTimeout(() => reject(new Error('PDF 生成超时，请检查图片资源后重试')), milliseconds);
    })
  ]).finally(() => clearTimeout(timer));
}

export default {
  install(Vue, options) {
    Vue.prototype.getPdf = async function (options = {}) {
      //打印的内容
      var title = this.htmlTitle;
      var ele = document.querySelector("#printId");
      //根据特定的class 筛选出来的List (防止文字被切断)
      let item = ele.querySelectorAll(".item");

      let order = JSON.parse(ele.getAttribute('data-order')).value
      console.log(order,'order');

      let num = JSON.parse(ele.getAttribute('data-num'))
      let arr = []
      for(let i = 0; i < num; i++) {
        arr.push([])
      }
      item.forEach(val => {
        if(val.getAttribute('data-type') === 'single') {
          arr[order.single - 1].push(val)
        }
        if(val.getAttribute('data-type') === 'multiple') {
          arr[order.multiple - 1].push(val)
        }
        if(val.getAttribute('data-type') === 'analyse') {
          arr[order.analyse - 1].push(val)
        }
        if(val.getAttribute('data-type') === 'blank') {
          arr[order.blank - 1].push(val)
        }
        if(val.getAttribute('data-type') === 'inference') {
          arr[order.inference - 1].push(val)
        }
      })
      console.log(item, 'item');
      console.log(arr,'arr');

      let itemOrder = [...Array.from(item).filter(val => val.getAttribute('data-type') === 'top'), ...arr.flat(2)]
      console.log(itemOrder,'itemOrder');

      let eleW = ele.offsetWidth; // 获得该容器的宽
      let eleH = ele.offsetHeight; // 获得该容器的高
      let eleOffsetTop = ele.offsetTop; // 获得该容器到文档顶部的距离
      let eleOffsetLeft = ele.offsetLeft; // 获得该容器到文档最左的距离

      var canvas = document.createElement("canvas");
      var abs = 0;

      let win_in =
        document.documentElement.clientWidth || document.body.clientWidth; // 获得当前可视窗口的宽度（不包含滚动条）
      let win_out = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）

      if (win_out > win_in) {
        // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
        abs = (win_out - win_in) / 2; // 获得滚动条宽度的一半
        // console.log(a, '新abs');
      }
      canvas.width = eleW * 1; // 将画布宽&&高放大两倍
      canvas.height = eleH * 1;

      var context = canvas.getContext("2d");
      context.scale(2, 2);
      context.translate(-eleOffsetLeft - abs, -eleOffsetTop);
      // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
      // translate的时候，要把这个差值去掉

      var pdf = new jsPDF("", "pt", "a4");

      let position = 0; //页面偏移
      let pageHeight = 801.89; //PDF页面高度
      const devicePixelRatio = window.devicePixelRatio // 获取下载的缩放 125% -> 1.25    150% -> 1.5
      const agent = navigator.userAgent.toLowerCase();
      if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
        if (devicePixelRatio === 1.25 || devicePixelRatio === 1.5) {
          ele.style.zoom = 1 * devicePixelRatio
        }
      }

      try {
      for (let i = 0; i < itemOrder.length; i++) {
        const render = html2canvas(itemOrder[i], { dpi: 600, useCORS: true, scale: 2, imageTimeout: options.renderTimeout ? 5000 : 15000 });
        canvas = options.renderTimeout ? await withTimeout(render, options.renderTimeout) : await render;

        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        // a4纸的尺寸[595.28,841.89]
        var imgWidth = 535.28; //图片宽度 原是595.38，因左右留白30，减去60
        let sourceY = 0;
        while (sourceY < contentHeight) {
          if (position === 0) position = 30;
          const available = pageHeight - position;
          if (available <= 1) {
            pdf.addPage();
            position = 30;
            pageHeight = 801.89;
            continue;
          }
          const sliceHeight = Math.min(contentHeight - sourceY, Math.max(1, Math.floor(available * contentWidth / imgWidth)));
          const slice = document.createElement('canvas');
          slice.width = contentWidth;
          slice.height = sliceHeight;
          slice.getContext('2d').drawImage(canvas, 0, sourceY, contentWidth, sliceHeight, 0, 0, contentWidth, sliceHeight);
          const renderedHeight = imgWidth * sliceHeight / contentWidth;
          pdf.addImage(slice.toDataURL('image/jpeg', 1.0), 'JPEG', 30, position, imgWidth, renderedHeight);
          sourceY += sliceHeight;
          position += renderedHeight;
          if (sourceY < contentHeight) {
            pdf.addPage();
            position = 30;
            pageHeight = 801.89;
          }
        }
      }
      } finally {
        ele.style.zoom = "";
      }
      if (options.returnBlob) return pdf.output('blob');
      pdf.save(title + ".pdf");
    };
  },
};
